import { motion, useReducedMotion } from 'motion/react';
import { listItemMotion } from './motion';

export default function StatCard({ label, value, hint, index = 0 }) {
  const reduceMotion = useReducedMotion();
  const motionProps = reduceMotion
    ? {}
    : { ...listItemMotion, transition: { ...listItemMotion.transition, delay: index * 0.04 } };

  return (
    <motion.div className="aui-stat-card" {...motionProps}>
      <div className="label">{label}</div>
      <div className="value">{value}</div>
      {hint && <div className="hint">{hint}</div>}
    </motion.div>
  );
}
